import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "ServiceDesk"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M21 18.0039V16.5039C20.9932 11.8279 17.4095 7.93464 12.75 7.54141V6.00391H15V4.50391H9V6.00391H11.25V7.54141C6.59054 7.93464 3.0068 11.8279 3 16.5039V18.0039H1.5V19.5039H22.5V18.0039H21ZM12 9.00391C15.5622 9.00882 18.6312 11.5147 19.3485 15.0039H4.65146C5.36873 11.5147 8.43777 9.00882 12 9.00391ZM4.5 16.5039H19.5V18.0039H4.5V16.5039Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/ServiceDesk.vue"]]);
